<template>
  <b-button
    v-bind="$attrs"
    class="button-link"
    :type="color"
    outlined
    :size="size"
    :icon-left="icon"
    :loading="loading"
    @click="$emit('click', $event)"
  >
    <slot></slot>
  </b-button>
</template>

<script>
export default {
  name: "ButtonLink",
  props: {
    loading: {
      type: Boolean
    },
    size: {
      type: String,
      default: 'is-small'
    },
    color: {
      type: String,
    },
    icon: String
  }
}
</script>

<style lang="scss" scoped>

.button-link {
  white-space: normal;
  text-align: left;
  line-height: 1.2;
}
</style>
